<section fxFlex fxLayout="column">
  <header>
    <h2>Import Database from File</h2>
  </header>
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="16px">
      <div><b>WARNING!</b> This will replace plans and related workout data with the contents of the import file.</div>
      <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="8px">
        <button mat-raised-button (click)="triggerClick()">Choose file</button>
        <div fxFlex>{{ fileObj ? fileObj.name : '' }}</div>
      </div>
      <div [hidden]="!fileContents">
        <div fxLayout="column" fxLayoutGap="8px">
          <b>Select Plans to Import</b>
          <section class="plan-list" fxLayout="column">
            <mat-checkbox *ngFor="let plan of plans" [(ngModel)]="plan.checked">
              {{ plan.name }}
              <em>{{ plan.date | date: 'shortDate' }}</em>
            </mat-checkbox>
            <span *ngIf="plans.length === 0">No plans found in import file.</span>
          </section>
        </div>
      </div>
      <div fxLayout="row">
        <button mat-raised-button (click)="uploadFile()" color="warn" [disabled]="!fileObj">Import</button>
      </div>

      <div [hidden]="!inProgress && !complete" class="progress-bar">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
          <mat-progress-bar class="launch-progress" mode="indeterminate" *ngIf="inProgress"></mat-progress-bar>
          <mat-progress-bar class="launch-progress" mode="determinate" value="100" *ngIf="!inProgress"></mat-progress-bar>
          <button mat-raised-button class="button-launch" color="primary" (click)="dialog.close()" [disabled]="inProgress">Launch</button>
        </div>
      </div>

      <input type="file" #file (change)="setFile()" [hidden]="true" />
    </div>
  </mat-dialog-content>
</section>
